import { apiErrorToToast } from "@/lib/utils";
import {
  updateAdditionalComments,
  UpdateAdditionalCommentsRequestParams,
} from "@/requests/questionnaries/update-additional-comments.request";
import { ApiErrorResponse } from "@/types/apis";
import { DimensionId } from "@/types/questionnaries";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

export type UpdateAdditionalCommentsMutationParams =
  UpdateAdditionalCommentsRequestParams & {
    dimension: DimensionId;
    topic: string;
  };

export const useUpdateAdditionalCommentsMutation = () => {
  return useMutation({
    mutationFn: (variables: UpdateAdditionalCommentsMutationParams) =>
      updateAdditionalComments(variables),
    onError: (error: AxiosError<ApiErrorResponse>) => {
      apiErrorToToast(error);
    },
  });
};
